import { normalizeString } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PSF_SHARE_INITIAL_ABOVE_BUTTON_MESSAGE = createFcmConfig('psf_share_initial_above_button_message', {
	normalizer: normalizeString,
	defaultValue: undefined,
});
